module.exports = __webpack_public_path__ + "img/djq_over.205cfcb4.png";